<template>
  <app-modal
    name="error-reported-modal"
    :title="title"
    hide-footer-button
    width="90%"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <b-tabs pills>
      <b-tab :title="titleUnreported" @click="onChangeTab(TYPE.UNREPORTED)" active>
        <error-reported-table
          ref="tableUnreported"
          :type="TYPE.UNREPORTED"
          :invoice-list="unreported.data"
          :is-loading="unreported.loading"
          :page-info="unreported.page_info"
          :selectedList="selectedList"
          @on-selected="onSelected"
          @on-page-click="(page) => onPageClick(page, TYPE.UNREPORTED)"
          @on-change-total="(value) => onChangeTotal(value, TYPE.UNREPORTED)"
        />
      </b-tab>
      <b-tab :title="titleReported"  @click="onChangeTab(TYPE.REPORTED)" >
        <error-reported-table
          :type="TYPE.REPORTED"
          :invoice-list="reported.data"
          :is-loading="reported.loading"
          :page-info="reported.page_info"
          @on-page-click="(page) => onPageClick(page, TYPE.REPORTED)"
          @on-change-total="(value) => onChangeTotal(value, TYPE.REPORTED)"
        />
      </b-tab>
      <template v-if="tab === TYPE.UNREPORTED" #tabs-end>
        <li style="flex: 1; display: flex; justify-content: flex-end; gap: 20px">
          <div class="form-group">
            <app-search-box
              :placeholder="$t('invoice.searchPlaceholder')"
              :value="searchText[tab]"
              @search="onSearch"
              @clear="onSearch"
              style="width: 400px"
              variant="fill"
            />
          </div>
          <date-picker
            :value="dateRange[tab]"
            @input="onPickDate"
            type="date"
            format="DD/MM/YYYY"
            range rangeSeparator=" - "
            placeholder="Select date range"
            input-class="custom-input-class"
            popup-class="custom-popup-class"
          />
        </li>
      </template>
    </b-tabs>
    <template v-slot:control>
      <div style="width: 100%; display: flex; justify-content: flex-end">
        <app-btn-submit @on-click="onDownloadErrorReport" icon="fas fa-eye" :is-submitting="isLoading" class="mr-3"
          v-if="selectedList.length && tab === TYPE.UNREPORTED" text="Xem trước trên Excel"></app-btn-submit>
        <app-btn-submit v-if="tab === TYPE.UNREPORTED" @on-click="onReportInvoices" :disabled="!selectedList.length"
          icon="fas fa-paper-plane" :is-submitting="isLoading" text="Ký và gửi CQT"></app-btn-submit>
      </div>
    </template>
  </app-modal>
</template>

<script>
import { mapState } from 'vuex';
import AppModal from '@/components/app-modal/';
import AppSearchBox from '@/components/app-search-box/';
import ErrorReportedTable from '@/portal-components/invoice/error-reported-table';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vi from 'date-format-parse/lib/locale/vi';
import { capitalize } from 'lodash';
import AppBtnSubmit from '@/components/app-button';
import InvoiceProxy from '../../store/proxies/invoice-proxy';
import DateTimeUtils from '../../utils/datetime';
import { EInvoiceProxy } from '../../store/proxies/e-invoice';
import SellerProxy from '../../store/proxies/e-invoice/seller-proxy';
import ToastUtils from '../../utils/toast';
import ReleaseInvoiceMixin from '../../mixins/release-invoice';
import { PublishedInvoiceProxy } from '@/store/proxies/e-invoice';
import {
  downloadFile,
  getFilenameFromResponse
} from '@/utils/download';

const TYPE = {
  UNREPORTED: 'UNREPORTED',
  REPORTED: 'REPORTED',
};

const lang = {
  formatLocale: {
    ...vi,
    months: vi.months.map(month => `${capitalize(month)},`),
  },
  yearFormat: 'YYYY',
  monthFormat: 'MMMM',
  monthBeforeYear: true,
};

DatePicker.locale('vi', lang);

function getDefaultData() {
  return {
    tab: TYPE.UNREPORTED,
    isLoading: false,
    selectedList: [],
    dateRange: {
      UNREPORTED: [new Date(), new Date()],
      REPORTED: [new Date(), new Date()],
    },
    searchText: {
      UNREPORTED: '',
      REPORTED: '',
    },
    sellerInfor: {
      approval_unit: null,
      approval_unit_code: null,
    },
    unreported: {
      data: [],
      loading: false,
      page_info: {
        total: 0,
        current_page: 1,
        current_limit: 5,
      },
    },
    reported: {
      data: [],
      loading: false,
      page_info: {
        total: 0,
        current_page: 1,
        current_limit: 5,
      },
    },
  };
}

const params = (ctx, invoice) => ({
  time_type: 'NGAY',
  year: '',
  time_value: '',
  from_date: invoice.issued_date,
  end_date: DateTimeUtils.formatDate(new Date(), 'YYYY-MM-DD'),
  list_invoice_number: invoice.invoice_number,
  approval_unit_code: ctx.sellerInfor.approval_unit_code,
  approval_unit: ctx.sellerInfor.approval_unit,
  invoice_type: 'normal',
  is_pos_invoice: true,
});

export default {
  name: 'ErrorReportedModal',
  mixins: [ReleaseInvoiceMixin],
  components: {
    AppModal,
    DatePicker,
    AppBtnSubmit,
    AppSearchBox,
    ErrorReportedTable,
  },
  data() {
    return {
      ...getDefaultData(),
      title: this.$t('invoice.listOfInvoiceErrorReports'),
    };
  },
  computed: {
    ...mapState([
      'invoiceGlobalSearchParams',
    ]),
    TYPE() {
      return TYPE;
    },
    titleUnreported() {
      const result = 'Chưa báo cáo';
      if (this.unreported.page_info.total) {
        return `${result} (${this.unreported.page_info.total})`;
      } return result;
    },
    titleReported() {
      const result = 'Đã báo cáo';
      if (this.reported.page_info.total) {
        return `${result} (${this.reported.page_info.total})`;
      } return result;
    },
  },
  methods: {
    fetchUnreportedList() {
      this.unreported.loading = true;
      const params = {
        bcss_status: 'CHUA_BAO_CAO',
        start_date: DateTimeUtils.formatDate(this.dateRange[TYPE.UNREPORTED][0], 'YYYY-MM-DD'),
        end_date: DateTimeUtils.formatDate(this.dateRange[TYPE.UNREPORTED][1], 'YYYY-MM-DD'),
        search_text: this.searchText[TYPE.UNREPORTED] || '',
        page: this.unreported.page_info.current_page,
        page_size: this.unreported.page_info.current_limit,
      };
      new InvoiceProxy(params)
        .getInvoices()
        .then((res) => {
          this.unreported = {
            loading: false,
            data: res.data,
            page_info: res.page_info,
          };
        })
        .catch((error) => {
          ToastUtils.showToast('error', error.message || error);
        })
        .finally(() => {
          this.unreported.loading = false;
        });
    },
    fetchReportedList() {
      this.reported.loading = true;
      new EInvoiceProxy()
        .getMistakeReports()
        .then((res) => {
          this.reported = {
            loading: false,
            data: res.data,
            page_info: res.page_info,
          };
        })
        .catch((error) => {
          ToastUtils.showToast('error', error.message || error);
        })
        .finally(() => {
          this.reported.loading = false;
        });
    },
    fetchSellerInformation() {
      new SellerProxy()
        .getSellerInformation()
        .then((res) => {
          if (res) {
            const { approval_unit, approval_unit_code } = res;
            this.sellerInfor = { approval_unit, approval_unit_code };
          }
        })
        .catch((error) => {
          ToastUtils.showToast('error', error.message || error);
        });
    },
    onChangeTab(tab) {
      this.tab = tab;
    },
    onSelected(selectedList) {
      this.selectedList = selectedList;
    },
    onPickDate(value) {
      if (this.tab === TYPE.UNREPORTED) {
        this.dateRange[TYPE.UNREPORTED] = value;
        this.fetchUnreportedList();
      } else if (this.tab === TYPE.REPORTED) {
        this.dateRange[TYPE.REPORTED] = value;
        this.fetchReportedList();
      }
    },
    onSearch(value) {
      if (this.tab === TYPE.UNREPORTED) {
        if (this.searchText[TYPE.UNREPORTED] === value) return;
        this.searchText[TYPE.UNREPORTED] = value;
        this.fetchUnreportedList();
      } else if (this.tab === TYPE.REPORTED) {
        if (this.searchText[TYPE.REPORTED] !== value) return;
        this.searchText[TYPE.REPORTED] = value;
        this.fetchReportedList();
      }
    },
    onPageClick(page, type) {
      if (type === TYPE.UNREPORTED) {
        this.unreported.page_info.current_page = page;
        this.fetchUnreportedList();
      } else if (type === TYPE.REPORTED) {
        this.reported.page_info.current_page = page;
        this.fetchReportedList();
      }
    },
    onChangeTotal(value, type) {
      if (type === TYPE.UNREPORTED) {
        this.unreported.page_info.current_limit = value;
        this.fetchUnreportedList();
      } else if (type === TYPE.REPORTED) {
        this.reported.page_info.current_limit = value;
        this.fetchReportedList();
      }
    },
    onReportInvoices() {
      if (!this.selectedList.length || !this.sellerInfor.approval_unit || !this.sellerInfor.approval_unit_code) {
        ToastUtils.showToast('error', 'Lỗi lấy dữ liệu từ phía máy chủ');
      }
      const promises = this.selectedList.map(invoice => this.reportInvoiceError(params(this, invoice)));
      Promise.all(promises)
        .then((results) => {
          if (results.length) {
            ToastUtils.showToast('success', 'Báo cáo cơ quan thuế thành công');
          }
        }).catch((errorCode) => {
          this.$modal.show('usb-token-error-modal', { model: { error: errorCode } });
        }).finally(() => {
          this.selectedList = [];
          this.$nextTick(() => {
            this.$refs.tableUnreported.clear();
          });
        });
    },
    async onDownloadErrorReport() {
      if (!this.selectedList.length || !this.sellerInfor.approval_unit || !this.sellerInfor.approval_unit_code) {
        ToastUtils.showToast('error', 'Lỗi lấy dữ liệu từ phía máy chủ');
      }

      const configs = {
        responseType: 'blob',
        showResponseHeaders: true
      };
      const promises = this.selectedList.map(async invoice => {
        try {
          const res = await new PublishedInvoiceProxy({
            ...params(this, invoice),
            is_pos_invoice: false,
            export_type: 'EXCEL',
            time_value: 2
          }).statisticMistakeInvoice(configs);
          downloadFile(getFilenameFromResponse(res), res.data);
          return res;
        } catch (err) {
          ToastUtils.showToast('error', err.message || err);
        } finally {
          this.selectedList = [];
          this.$nextTick(() => {
            this.$refs.tableUnreported.clear();
          });
        }
      });
      try {
        await Promise.all(promises);
        ToastUtils.showToast('success', 'Tải báo cáo thành công');
      } catch (e) {
        ToastUtils.showToast('error', e.message || e);
      }
    },
    resetData() {
      Object.assign(this.$data, {
        ...getDefaultData(),
        title: this.$t('invoice.listOfInvoiceErrorReports'),
      });
    },
    beforeOpen(props) {
      const { model } = props;
      const { start_date, end_date, search_text: searchText } = this.invoiceGlobalSearchParams;
      this.dateRange = {
        UNREPORTED: [new Date(start_date), new Date(end_date)],
        REPORTED: [new Date(start_date), new Date(end_date)],
      };
      this.searchText = {
        UNREPORTED: searchText || '',
        REPORTED: searchText || '',
      };
      if (model) {
        this.selectedList = [model];
      }
      this.fetchUnreportedList();
      this.fetchReportedList();
      this.fetchSellerInformation();
    },
    beforeClose() {
      this.resetData();
    },
  },
};
</script>
<style>
.custom-input-class {
  color: #495057;
  border-radius: 10px;
  background-color: #E4F4FF;
  height: 48px;
  border: none;
  font-size: 14px;
  padding: 6px;
  width: 100%;
  &:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
}

.custom-popup-class {
  font-family: "Nunito";
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0em;
}

.custom-popup-class .mx-btn-current-month,
.custom-popup-class .mx-btn-current-year {
  color: #005DCA;
}

.mx-datepicker-range {
  max-width: 400px;
  width: 100%;
  min-width: 200px;
}

.mx-icon-calendar svg {
  color: #005DCA;
}

.nav {
  .nav-item {
    margin-right: 20px;
    .nav-link {
      padding: 12px 40px;
      color: #495057;
      background-color: #F0F5FA;
    }
    .active {
        color: #495057;
        background-color: #005DCA33;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/error-reported-modal.vue